import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "facebook-follow__block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "facebook-follow__title" }, "Kövess minket, és értesülj a friss hírekről a Facebookon is!", -1)
const _hoisted_4 = {
  href: "https://www.facebook.com/rtlponthu",
  target: "_blank",
  class: "facebook-follow__button"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Követem ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_facebook_full = _resolveComponent("facebook-full")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["facebook-follow", {[`facebook-follow--${_ctx.type}`]: _ctx.type}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_component_facebook_full),
          _hoisted_5
        ])
      ])
    ])
  ], 2))
}